import * as Immutable from "immutable";

const ProjectMap = Immutable.OrderedMap;

export default ProjectMap;
